import api from './api';

// Owner / agent tools that sit on top of real organisation and property data.
const landlordService = {
  organisations: async () => (await api.get('/organisations')).data,
  createOrganisation: async (data) => (await api.post('/organisations', data)).data,
  properties: async (organisationId) => (await api.get(`/organisations/${organisationId}/properties`)).data,

  applyLink: async (propertyId) => (await api.get(`/properties/${propertyId}/apply-link`)).data,
  enableApplyLink: async (propertyId) => (await api.post(`/properties/${propertyId}/apply-link`)).data,
  disableApplyLink: async (propertyId) => (await api.delete(`/properties/${propertyId}/apply-link`)).data,

  comparison: async (propertyId) => (await api.get(`/properties/${propertyId}/comparison`)).data
};

export default landlordService;
